import { Carousel } from "antd";
const CarouselTab = ({ content }) => (
  <Carousel autoplay>
    {content.map((item, idx) => (
      <div className="!flex !justify-center !items-center !p-5" key={idx}>
        <img
          src={item}
          alt="carousel-img"
          className="max-h-[80vh] w-[100%] max-w-[100vw] object-contain"
        />
      </div>
    ))}
  </Carousel>
);
export default CarouselTab;
